import pages from '../../routes/pages';
import { matchPath } from 'react-router-dom';

export const getPageNameFromPath = path => {
  const infos = Object.keys(pages)
    .map(obj => pages[obj])
    .find(page => {
      if (page.path === path) return page;
      if (
        page.path ===
        matchPath(path, {
          path: page.path,
          exact: true
        })?.path
      )
        return page;
      return null;
    });
  if (!infos) return null;
  return infos;
};
